import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import AppFlexbox from '../../common/AppFlexbox';
import { useOnScreen } from '../../../helpers/hooks';
import BulkEditDataRow from './BulkEditDataRow';

const BulkEditDataRowVirtualized = ({
  row,
  displayedFields,
  dataFields,
  optionsState,
  onlySubrows,
  onRowChange,
  onSubrowChange,
  onSelectRow,
  onSelectSubrow
}) => {
  const ref = useRef(null);
  const isShowing = useOnScreen(ref);
  const sectionHeight =
    37 *
    (onlySubrows
      ? row.subrows.length
      : 1 + (row.subrows ? row.subrows.length : 0));

  return (
    <AppFlexbox
      ref={ref}
      style={{
        gridTemplateColumns: `repeat(${displayedFields.length}, max-content)`,
        width: '100%',
        display: 'grid',
        gridColumnGap: 0,
        gridRowGap: 0,
        position: 'relative',
        minHeight: sectionHeight,
        gridColumn: '1 / -1',
        backgroundColor: '#f5f5f5',
        backgroundClip: 'padding-box'
      }}
    >
      {isShowing && (
        <BulkEditDataRow
          dataFields={dataFields}
          displayedFields={displayedFields}
          onlySubrows={onlySubrows}
          onRowChange={onRowChange}
          onSelectRow={onSelectRow}
          onSelectSubrow={onSelectSubrow}
          onSubrowChange={onSubrowChange}
          optionsState={optionsState}
          row={row}
        />
      )}
    </AppFlexbox>
  );
};

BulkEditDataRowVirtualized.propTypes = {
  dataFields: PropTypes.array,
  displayedFields: PropTypes.array,
  onRowChange: PropTypes.func,
  onSelectRow: PropTypes.func,
  onSelectSubrow: PropTypes.func,
  onSubrowChange: PropTypes.func,
  onlySubrows: PropTypes.bool,
  optionsState: PropTypes.object,
  row: PropTypes.object
};

export default BulkEditDataRowVirtualized;
